export default __webpack_public_path__ + "541d6d66a3208f469a113d2cb9dd2644.gif";